import { render, staticRenderFns } from "./LanguageNoticeDialog.vue?vue&type=template&id=646ba164&scoped=true"
import script from "./LanguageNoticeDialog.vue?vue&type=script&lang=ts"
export * from "./LanguageNoticeDialog.vue?vue&type=script&lang=ts"
import style0 from "../styles/language-notice-dialog.css?vue&type=style&index=0&id=646ba164&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ba164",
  null
  
)

export default component.exports